import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'event_media_viewer';
export const useEventMediaViewerTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => {
  return useTranslation('widgets', { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    tab_frame: 'Кадр',
    tab_video_archive: 'Видеоархив',
    no_data: 'Нет данных',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    tab_frame: 'Frame',
    tab_video_archive: 'Video archive',
    no_data: 'No data',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    tab_frame: 'Marco',
    tab_video_archive: 'Archivo de vídeo',
    no_data: 'Sin datos',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    tab_frame: 'Quadro',
    tab_video_archive: 'Arquivo de vídeos',
    no_data: 'Sem dados',
  },
}) : {}) as Record<string, unknown>;
